import { createAction } from "@reduxjs/toolkit";

import type { UUID } from "utils";

export const sendProductInterest = createAction<{
  productName: string;
  userId: UUID;
}>("productInterest");

export const userOperationPaths = () => ({
  productInterest: ["users", "product-interest"],
});
